<template>
  <CModal
    @mtdclosemodal="mtdCloseModal"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="false"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="row px-3">
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <label class="form-label">Diseño</label>
        <select class="form-control form-control-sm" v-model="detail.desing">
          <option value="0">[Seleccione un diseño... ]</option>
          <option v-for="(item, index) in lstDesing" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <label class="form-label">IR/n - Material</label>
        <select class="form-control form-control-sm" v-model="detail.material">
          <option value="0">[Seleccione un material... ]</option>
          <option v-for="(item, index) in lstMaterial" :key="index" :value="item.id">
          {{ item.material != null ? item.material["code"] : "" }}
            {{ item.name }}
          </option>
        </select>      
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
        <label class="form-label">Rango</label>
        <select class="form-control form-control-sm" v-model="detail.rango">
          <option value="0">[Seleccione un rango... ]</option>
          <option v-for="(item, index) in lstRango" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-md-4 mt-3 pt-1">
        <label class="form-label">Colores</label>
        <v-select
          v-model="detail.colors"
          :options="lstColor"
          label="text"
          multiple
          :reduce="(color) => color.name"
          placeholder="-- Seleccione colores --"
        >
          <!-- Opción en el dropdown -->
          <template #option="{ color, name }">
            <div class="color-option">
              <span
                class="color-box"
                :style="{ backgroundColor: name }"
              ></span>
              {{ color }} ({{ name }})
            </div>
          </template>

          <!-- Opción cuando se selecciona -->
          <template #selected-option="{ color, name }">
            <div class="color-option">
              <span
                class="color-box"
                :style="{ backgroundColor: name }"
              ></span>
              {{ color }}
            </div>
          </template>
        </v-select>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-3 pt-1">
        <label class="form-label">Add</label>
        <select class="form-control form-control-sm" v-model="detail.add">
          <option value="0">[Seleccione un adición... ]</option>
          <option v-for="(item, index) in lstAdd" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12 mt-3 pt-1">
        <label class="form-label">Altura</label>
        <select class="form-control form-control-sm" v-model="detail.height">
          <option value="0">[Seleccione una altura... ]</option>
          <option v-for="(item, index) in lstHeight" :key="index" :value="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-md-12 mt-3 pt-1">
        <label class="form-label">Precios de compra</label>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>SIMPLE</th>
              <th>DURAQUARZ</th>
              <th>AR 16</th>
              <th>AR SKY</th>
              <th>AR CELAN & CLEAR</th>
              <th>OTRO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-for="(item, index) in detail.price" :key="index"><input type="text" class="form-control form-control-sm" v-model="item.price"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #footer>
      <button class="btn btn-danger btn-sm" @click="mtdCloseModal">
        <i class="fas fa-times"></i> Cerrar
      </button>
      &nbsp;
      <button @click="mtdStoreTopsa" class="btn btn-success btn-sm" :disabled="cpButton">
        <i v-if="id == 0" class="fas fa-save"></i>
        <i v-else class="fas fa-edit"></i>
        {{ id == 0 ? "Guardar" : "Editar" }}
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/CModal.vue";
import { mapActions } from "vuex";

export default {
  name: "c-maintenance-modal-documento",
  components: {
    CModal,
  },
  data() {
    return {
      detail: {
        desing: "0",
        material: 0,
        colors: [],
        rango: 0,
        add:0,
        height:0,
        price:[
          {text: "simple",price:""},
          {text: "duraquarz",price:""},
          {text: "ar_16",price:""},
          {text: "ar_sky",price:""},
          {text: "ar_clean",price:""},
          {text: "other",price:""},
        ]
      },
    };
  },
  watch: {},
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    lstDesing: Array,
    lstMaterial: Array,
    lstRango: Array,
    lstColor: Array,
    lstAdd: Array,
    lstHeight: Array,
    lstMaterialCod: Array
  },
  computed: {
    cpButton() {
      return !(this.detail.desing != "");
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdCloseModal() {
      this.$emit("mtdCloseModal");
    },
    mtdStoreTopsa: function(){
      this.$emit("mtdStoreTopsa",this.detail);
    }
  },
};
</script>
<style>
.color-option {
  display: flex;
  align-items: center;
}
.color-box {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
</style>